import { render, staticRenderFns } from "./ScrubBarLabel.vue?vue&type=template&id=3a75ad87&scoped=true&"
import script from "./ScrubBarLabel.vue?vue&type=script&lang=js&"
export * from "./ScrubBarLabel.vue?vue&type=script&lang=js&"
import style0 from "./ScrubBarLabel.vue?vue&type=style&index=0&id=3a75ad87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a75ad87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
